@if (error) {
  <div
    class="flex flex-col items-center justify-center gap-2 p-6 text-center text-red-700"
    [style]="'height: calc(100% - ' + pdfActions.offsetHeight + 'px)'"
  >
    <mat-icon class="h-[48px] w-[48px] text-[48px]">error_outline</mat-icon>
    <span>{{ error }}</span>
  </div>
}
@if (pdfSrc) {
  <pdf-viewer
    [src]="pdfSrc"
    [render-text]="true"
    [original-size]="false"
    [zoom]="zoomLevel"
    class="block w-full"
    [style]="'height: calc(100% - ' + pdfActions.offsetHeight + 'px)'"
    (wheel)="onWheel($event)"
  ></pdf-viewer>
}

<div
  #pdfActions
  class="sm:bottom-15 absolute bottom-5 left-1/2 z-10 flex -translate-x-1/2 items-center gap-3 rounded-3xl bg-[var(--mat-sys-surface-container-highest)] bg-opacity-70 px-4 py-2 shadow-md dark:bg-[var(--mat-sys-surface-container-lowest)] sm:gap-2 sm:px-3 sm:py-1.5"
>
  <button
    mat-icon-button
    class="w-8 h-8 transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-40 sm:h-7 sm:w-7"
    (click)="zoomOut()"
    [disabled]="zoomLevel <= 0.5"
    aria-label="Zoom out"
  >
    <mat-icon class="text-[20px]">zoom_out</mat-icon>
  </button>

  <span
    class="min-w-[50px] text-center text-sm font-medium sm:min-w-[40px] sm:text-xs"
    >{{ zoomLevel * 100 | number: '1.0-0' }}%</span
  >

  <button
    mat-icon-button
    class="w-8 h-8 transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-40 sm:h-7 sm:w-7"
    (click)="zoomIn()"
    [disabled]="zoomLevel >= 3"
    aria-label="Zoom in"
  >
    <mat-icon class="text-[20px]">zoom_in</mat-icon>
  </button>

  <button
    mat-icon-button
    class="w-8 h-8 transition-colors duration-200 sm:h-7 sm:w-7"
    (click)="resetZoom()"
    aria-label="Reset zoom"
  >
    <mat-icon class="text-[20px]">refresh</mat-icon>
  </button>
</div>
